package com.patronat.top.client.domain.venues

import com.patronat.top.client.data.venues.ClientVenuesRepository
import com.patronat.top.core.dispatchers.DispatcherProvider
import com.patronat.top.core.domain.models.DomainResult
import com.patronat.top.domain.usecase.BaseUseCase
import com.patronat.top.dto.VenueServiceSuggestionsResponse

class GetClientVenueServiceSuggestionsUseCase(
    private val repository: ClientVenuesRepository,
    dispatcherProvider: DispatcherProvider
) : BaseUseCase<String, DomainResult<VenueServiceSuggestionsResponse>>(
    dispatcher = dispatcherProvider.io
) {
    override suspend fun doWork(command: String): DomainResult<VenueServiceSuggestionsResponse> {
        return repository.suggestServices(command)
    }
}
